import { render, staticRenderFns } from "./LabelTitle.vue?vue&type=template&id=15fe8f5a&scoped=true&lang=pug&"
import script from "./LabelTitle.vue?vue&type=script&lang=ts&"
export * from "./LabelTitle.vue?vue&type=script&lang=ts&"
import style0 from "./LabelTitle.vue?vue&type=style&index=0&id=15fe8f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe8f5a",
  null
  
)

export default component.exports